import { BorderedInput, Typography } from '@navi/web-ui/lib/primitives';
import { Controller } from 'react-hook-form';
import RequiredIcon from '@navi/web-ui/lib/icons/RequiredIcon';
import ErrorIconOutline from '@cp/src/assets/icons/ErrorIconOutline';
import cx from 'classnames';
import styles from './index.module.scss';
import { LoadingIcon } from '@navi/web-ui/lib/icons';
import { IAddressFormTextInput } from './interfaces';
import { isFunction } from '@cp/src/utils/commonUtils';

const AddressFormTextInput = (props: IAddressFormTextInput) => {
  const {
    control,
    name,
    rules,
    errors,
    isEditDisabled = false,
    inputLabel,
    placeholder,
    showRequiredIcon = false,
    containerClass,
    handlePincodeChange,
    isPincodeLoading = false
  } = props;
  const handleValueChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    onChange: (...event: any[]) => void
  ) => {
    const value = e.target.value;
    if (name === 'pinCode' && isFunction(handlePincodeChange)) {
      handlePincodeChange(value, onChange);
    } else {
      onChange(value);
    }
  };
  return (
    <>
      <div className={cx('flex items-center', containerClass)}>
        <Typography color="var(--grayscale-2)" variant={'p4'}>
          {inputLabel}
          {showRequiredIcon ? <RequiredIcon className="mb-1 ml-1" /> : null}
        </Typography>
      </div>
      <Controller
        control={control}
        name={name}
        rules={rules}
        render={({ field: { onChange, value, onBlur } }) => (
          <BorderedInput
            placeholder={placeholder}
            fullWidth
            onChange={e => handleValueChange(e, onChange)}
            value={value}
            disabled={isEditDisabled}
            RightInputAdornment={isPincodeLoading ? <LoadingIcon /> : null}
            onBlur={onBlur}
          />
        )}
      />
      {errors?.[name]?.message && (
        <div className={styles.errorContainer}>
          <ErrorIconOutline />
          <Typography variant="p4" className={styles.errorText}>
            {errors?.[name]?.message}
          </Typography>
        </div>
      )}
    </>
  );
};

export default AddressFormTextInput;
